import type { ID } from '@octopus-do/octopus-project-core'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  EllipsisVertical,
  Folder as FolderIcon,
} from '@octopus-do/octopus-storybook/icons'
import type { WorkspaceItem } from '@store/reducers/dashboard/types'
import { countOwnActiveProjects } from '@store/reducers/dashboard/utils'
import React from 'react'

import { clsJoin } from '@/utils'
import { PROJECTS_COUNT_CLASS_NAME } from '../../../../../../Folders'
import { FolderContainer } from '../../../../../FolderContainer'
import { FolderLink } from '../../../../../FolderLink'
import css from './styles.module.css'

interface Props {
  folder: WorkspaceItem
  workspaceId: ID
  activeFolder: string | null
}

export const FolderMenuTrigger = React.forwardRef<HTMLButtonElement, Props>(
  ({ workspaceId, folder, activeFolder }, ref) => {
    const { active: activeMenu, open } = DropdownMenu.useTrigger()

    const { title, id } = folder
    const active = activeFolder === id
    const count = countOwnActiveProjects(folder)

    return (
      <FolderContainer
        active={active}
        className={clsJoin(css.folder, activeMenu && css.active_menu)}
      >
        <FolderLink
          activeFolder={activeFolder}
          workspace={{ id: workspaceId }}
          folderId={id}
          title={title}
        >
          <FolderIcon />
        </FolderLink>

        {!!count && (
          <div className={clsJoin(PROJECTS_COUNT_CLASS_NAME, css.count)}>
            {count}
          </div>
        )}

        <div className={clsJoin(css.button_wrap, activeMenu && css.show)}>
          <button
            ref={ref}
            className={clsJoin(css.button, activeMenu && css.open)}
            onPointerDown={open}
          >
            <EllipsisVertical className={css.icon} />
          </button>
        </div>
      </FolderContainer>
    )
  }
)
